// extracted by mini-css-extract-plugin
export var active = "language-nav-module--active--CI6DB";
export var link = "language-nav-module--link--xhDIN";
export var list = "language-nav-module--list--tXqbp";
export var nav = "language-nav-module--nav--Va8ZA";